import { CustomSelectProps } from 'components/CustomSelect/CustomSelect.props';
import useMeasurementDateListOptions from 'pages/Waterfall/components/MeasurementDateList/useMeasurementDateListOptions';
import WaterfallSearchableCellSelect from 'pages/Waterfall/components/WaterfallSearchableCellSelect';

const MeasurementDateList = (props: CustomSelectProps) => {
  const { cell, onCommit, onRevert } = props;

  const { options } = useMeasurementDateListOptions();

  return (
    <WaterfallSearchableCellSelect
      cell={cell}
      emptyMessage="No cap table dates found"
      id="measurement-date-list"
      itemLabelPlural="cap table dates"
      itemLabelSingular="cap table date"
      onCommit={onCommit}
      onRevert={onRevert}
      options={options}
      searchPlaceholder="Find a Cap Table Date"
    />
  );
};

export default MeasurementDateList;
